module.exports = __webpack_public_path__ + "static/media/IUP_zast_L4.07a16f25.svg";